// @ts-ignore

import { CustomerAppConfig, DeploymentConfig } from '@cs/common/classes';
import config                                  from './environment.config.json';
// @ts-ignore
import details                                 from './deployment-details.json';


import { Environment } from '@cs/common';


export const dsnSentry = config.dsnSentry;

export const baseCustomerVars: CustomerAppConfig = {
	title       : config.title,
	supportEmail: config.supportEmail,
	customerName: config.customerName
};

export const deploymentVars: DeploymentConfig = {
	environment        : config.environment as Environment,
	useMockData        : config.useMockData,
	apiEndpoint        : config.apiUrl, // Only change if the regular naming convention is not used
	translationLocation: config.translationLocation,
	googleMapsApiKey   : config.googleMapsApiKey,
	// Some weird stuff is happening when settin the deploymentDetails directly
	deploymentDetails: {
		buildDate   : details.buildDate,
		version     : details.version,
		repositories: details.repositories,
		detailsUrl  : details.detailsUrl
	}
};
